export default __webpack_public_path__ + "static/media/logo.b63f1556.png";